import { dbiPageLogMes } from '@/pages/intelligence/utils/buriedPointCfg';
import { PC_CONSOLE_COMBINE_ENTITY_TYPE } from '@intelligence/pages/TopCharts/_config/topChartsConst';

const entityTypeTabMapping = {
  mobile: {
    stats: {
      activeusers: dbiPageLogMes.mobileGameDetailsStatsActiveUsers,
      revenue: dbiPageLogMes.mobileGameDetailsStatsRevenue,
      downloads: dbiPageLogMes.mobileGameDetailsStatsDownloads,
      retention_lifetime: dbiPageLogMes.mobileGameDetailsStatsRetentionLifetime,
      retention_monthly_sensortower: dbiPageLogMes.mobileGameDetailsStatsRetentionMonthly,
      retention_monthly: dbiPageLogMes.mobileGameDetailsStatsRetentionMonthly,
      rpd: dbiPageLogMes.mobileGameDetailsStatsRPD,
    },
    countries: {
      activeusers: dbiPageLogMes.mobileGameDetailsCountriesActiveUsers,
      revenue: dbiPageLogMes.mobileGameDetailsCountriesRevenue,
      downloads: dbiPageLogMes.mobileGameDetailsCountriesDownloads,
      retention_lifetime: dbiPageLogMes.mobileGameDetailsCountriesRetentionLifetime,
      retention_monthly_sensortower: dbiPageLogMes.mobileGameDetailsCountriesRetentionMonthly,
      retention_monthly: dbiPageLogMes.mobileGameDetailsCountriesRetentionMonthly,
      rpd: dbiPageLogMes.mobileGameDetailsCountriesRPD,
    },
  },
  pc: {
    stats: {
      pcu: dbiPageLogMes.pcGameDetailsStatsPCU,
      gsd: dbiPageLogMes.pcGameDetailsStatsGSDSaleData,
      digitalRevenue: dbiPageLogMes.pcGameDetailsStatsDigitalRevenue,
      physicalRevenue: dbiPageLogMes.pcGameDetailsStatsPhysicalRevenue,
      steamSales: dbiPageLogMes.pcGameDetailsStatsSteamSales,
      newzooMetrics: dbiPageLogMes.pcGameDetailsStatsNewzooMetrics,
    },
    countries: {
      pcu: dbiPageLogMes.pcGameDetailsCountriesPCU,
      gsd: dbiPageLogMes.pcGameDetailsCountriesGSDSaleData,
      digitalRevenue: dbiPageLogMes.pcGameDetailsCountriesDigitalRevenue,
      physicalRevenue: dbiPageLogMes.pcGameDetailsCountriesPhysicalRevenue,
      steamSales: dbiPageLogMes.pcGameDetailsCountriesSteamSales,
      newzooMetrics: dbiPageLogMes.pcGameDetailsCountriesNewzooMetrics,
    },
  },
  console: {
    stats: {
      gsd: dbiPageLogMes.consoleGameDetailsStatsGSDSaleData,
      digitalRevenue: dbiPageLogMes.consoleGameDetailsStatsDigitalRevenue,
      physicalRevenue: dbiPageLogMes.consoleGameDetailsStatsPhysicalRevenue,
      japanSales: dbiPageLogMes.consoleGameDetailsStatsJapanSales,
      newzooMetrics: dbiPageLogMes.consoleGameDetailsStatsNewzooMetrics,
    },
    countries: {
      gsd: dbiPageLogMes.consoleGameDetailsCountriesGSDSaleData,
      digitalRevenue: dbiPageLogMes.consoleGameDetailsCountriesDigitalRevenue,
      physicalRevenue: dbiPageLogMes.consoleGameDetailsCountriesPhysicalRevenue,
      japanSales: dbiPageLogMes.consoleGameDetailsCountriesJapanSales,
      newzooMetrics: dbiPageLogMes.consoleGameDetailsCountriesNewzooMetrics,
    },
  },
  [PC_CONSOLE_COMBINE_ENTITY_TYPE]: {
    stats: {
      allMetrics: dbiPageLogMes.pcConsoleGameDetailsStatsAllMetrics,
      gsd: dbiPageLogMes.pcConsoleGameDetailsStatsGSDSaleData,
      digitalRevenue: dbiPageLogMes.pcConsoleGameDetailsStatsDigitalRevenue,
      physicalRevenue: dbiPageLogMes.pcConsoleGameDetailsStatsPhysicalRevenue,
      steamSales: dbiPageLogMes.pcConsoleGameDetailsStatsSteamData,
      consoleData: dbiPageLogMes.pcConsoleGameDetailsStatsConsoleData,
      japanSales: dbiPageLogMes.pcConsoleGameDetailsStatsJapanSales,
      newzooMetrics: dbiPageLogMes.pcConsoleGameDetailsStatsNewzooMetrics,
    },
    countries: {
      gsd: dbiPageLogMes.pcConsoleGameDetailsCountriesGSDSaleData,
      digitalRevenue: dbiPageLogMes.pcConsoleGameDetailsCountriesDigitalRevenue,
      physicalRevenue: dbiPageLogMes.pcConsoleGameDetailsCountriesPhysicalRevenue,
      steamSales: dbiPageLogMes.pcConsoleGameDetailsCountriesSteamData,
      consoleData: dbiPageLogMes.pcConsoleGameDetailsCountriesConsoleData,
      japanSales: dbiPageLogMes.pcConsoleGameDetailsCountriesJapanSales,
      newzooMetrics: dbiPageLogMes.pcConsoleGameDetailsCountriesNewzooMetrics,
      ampere: dbiPageLogMes.pcConsoleGameDetailsCountriesUserEngagementAmpere,
    },
  },
} as any;
export const getStatsPageLogMes = (entityType: string, tab: string) => {
  return entityTypeTabMapping[entityType]?.stats?.[tab] || null;
};

export const getCountroesPageLogMes = (entityType: string, tab: string) => {
  return entityTypeTabMapping[entityType]?.countries?.[tab] || null;
};

export const DownloadTitleTips = 'dbi_download_title_tips';
